module.exports = __webpack_public_path__ + "static/media/backgroundVideo.36db3f61.mp4";